import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-scheduled-time-modal',
  templateUrl: './scheduled-time-modal.component.html',
  styleUrls: ['./scheduled-time-modal.component.scss']
})
export class ScheduledTimeModalComponent {
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() lading_uuid: string | undefined | null;
  @Input() field: string = '';

  successfulUpdate = false;

  forms = this.fb.group({
    delivery_date: [new Date()],
    delivery_time: ['00:00'],
    pickup_date: [new Date()],
    pickup_time: ['00:00'],
    appointment_date: [new Date()],
    appointment_start: ['00:00'],
    appointment_end: ['00:00'],
  })
  shipper_timezone: string | null = null;
  consignee_timezone: string | null = null;

  ngOnInit(){
    let url = `/api/work_orders/new_work_order_grid_details.php?uuid=${this.lading_uuid}`;
    // set timezones and current dates/times
    this.http.get<any>(url).subscribe(response => {
      if(response.shipper.address.timezone_id){
        this.shipper_timezone = response.shipper.address.timezone_id;
        if(this.shipper_timezone != null){
          if(this.shipper_timezone in this.timezone_regions){
            this.shipper_timezone = this.timezone_regions[this.shipper_timezone]
          }
        }
      }
      if(response.consignee.address.timezone_id){
        this.consignee_timezone = response.consignee.address.timezone_id;
        if(this.consignee_timezone != null){
          if(this.consignee_timezone in this.timezone_regions){
            this.consignee_timezone = this.timezone_regions[this.consignee_timezone]
          }
        }
      }
      if(response.ladings.load_start){
        let dateParts = response.ladings.load_start.substring(0, 10).split('-');
        let newDateFormat = `${dateParts[1]}-${dateParts[2]}-${dateParts[0]}`;
        this.forms.get('pickup_date')?.setValue(new Date(newDateFormat));
        this.forms.get('pickup_time')?.setValue(response.ladings.load_start.substring(11, 16))
      }
      if(response.ladings.load_end){
        let dateParts = response.ladings.load_end.substring(0, 10).split('-');
        let newDateFormat = `${dateParts[1]}-${dateParts[2]}-${dateParts[0]}`;
        this.forms.get('delivery_date')?.setValue(new Date(newDateFormat));
        this.forms.get('delivery_time')?.setValue(response.ladings.load_end.substring(11, 16))
      }
      if(response.ladings.appointment_date){
        let dateParts = response.ladings.appointment_date.substring(0, 10).split('-');
        let newDateFormat = `${dateParts[1]}-${dateParts[2]}-${dateParts[0]}`;
        this.forms.get('appointment_date')?.setValue(new Date(newDateFormat));
      }
      if(response.ladings.appointment_start){
        this.forms.get('appointment_start')?.setValue(response.ladings.appointment_start);
      }
      if(response.ladings.appointment_end){
        this.forms.get('appointment_end')?.setValue(response.ladings.appointment_end);
      }
    })
  }


  onCloseModal(saveChanges: boolean){
    this.closeModal.emit(saveChanges);
  }

  onSubmit(){
    let postData = {};
    if(this.field === 'pickup'){
      let formattedDateString = this.convertDate(this.forms.get('pickup_date')?.value);
      let formattedTimeString = this.convertTo24Hr(this.forms.get('pickup_time')?.value);
      console.log(this.forms.get('pickup_time')?.value)
      postData = {
        ladings: {
          lading_uuid: this.lading_uuid,
          load_start: this.convertDateTime(this.forms.get('pickup_date'), this.forms.get('pickup_time'))
        }
      }
      console.log(postData)
    }
    else if(this.field === 'delivery'){
      let formattedDateString = this.convertDate(this.forms.get('delivery_date')?.value);
      let formattedTimeString = this.convertTo24Hr(this.forms.get('delivery_time')?.value);
      postData = {
        ladings: {
          lading_uuid: this.lading_uuid,
          load_end: this.convertDateTime(this.forms.get('delivery_date'), this.forms.get('delivery_time'))
        }
      }
        
    }
    else if(this.field === 'appointment'){
      console.log(`appointment start time is... ${this.forms.get('appointment_start')?.value}`)
      let formattedDateString = this.convertDate(this.forms.get('appointment_date')?.value);
      let formattedStartTime = this.convertDateTime(this.forms.get('appointment_date'), this.forms.get('appointment_start'));
      let formattedEndTime = this.convertDateTime(this.forms.get('appointment_date'), this.forms.get('appointment_end'));
      postData = {
        ladings: {
          lading_uuid: this.lading_uuid,
          appointment_date: new Date(formattedDateString),
          appointment_start: formattedStartTime,
          appointment_end: formattedEndTime
        }
      }
      console.log(postData)
    }
    else{
      return;
    }
    this.http.post<any>(`/api/work_orders/new_work_order_grid_details.php`, postData).subscribe(
      (response)=> {
        console.log('date/time updated');
        console.log(response);
        this.successfulUpdate = true;
      },
      (error) => {
        console.error('error: ', JSON.stringify(error));
        console.log('postData: ', JSON.stringify(postData))
      }
    )
    this.onCloseModal(true);
  }

  // convert edited date and time into a string before posting
  convertDateTime(date: any, time: any) {
    console.log('time is... ', time.dirty ? 'changed' : 'unchanged')
    let hours: number;
    let minutes: number;
    // edited times in this format: 9:30 PM
    if (time.dirty) {
      let timeValue = time?.value || '';
      let [hourMinute, period] = timeValue.split(' ');
      let [hourStr, minuteStr] = hourMinute.split(':');
      hours = +hourStr;
      minutes = +minuteStr;

      // make 12hr to 24hr conversion
      if(period === 'PM' && hours !== 12){
        hours += 12;
      }
      // account for midnight
      else if(period === 'AM' && hours === 12){
        hours = 0;
      }

      // look at my noob code
      // hours = +time?.value.substring(0, time?.value.indexOf(':')) + (+time?.value.includes('P') ? 12 : 0);
      // minutes = +time?.value.substring(time?.value.indexOf(':') + 1, time?.value.indexOf(':') + 3);

      console.log(`hours: ${hours}, min: ${minutes}, original time: ${timeValue}`)
    }
    // unedited times are in this format: 21:30
    else {
      hours = +time?.value.substring(0, 2)
      minutes = +time?.value.substring(3);
      console.log(hours)
      console.log(minutes)
    }

    date?.value.setHours(hours);
    date?.value.setMinutes(minutes);

    let formattedDateTime: string = '';
    formattedDateTime += date?.value.getFullYear();
    formattedDateTime += '-' + String(date?.value.getMonth()+1).padStart(2, '0');
    formattedDateTime += '-' + String(date?.value.getDate()).padStart(2,'0');
    formattedDateTime += ' ' + String(date?.value.getHours()).padStart(2,'0');
    formattedDateTime += ':' + String(date?.value.getMinutes()).padStart(2,'0');
    formattedDateTime += ':' + String(date?.value.getSeconds()).padStart(2, '0');

    return formattedDateTime;
    // return date?.value.toISOString().substring(0, 19).replace('T', ' ');
  }

  convertDate(date: any){
    // Get day, month, and year from dateObject
    const day = date.getDate();
    const month = date.getMonth() + 1; // Month is 0-based
    const year = date.getFullYear();

    // Construct the formatted date string
    const formattedDate = this.padZero(month) + '/' + this.padZero(day) + '/' + year;

    return formattedDate;
  }

  convertTo24Hr(timeString: any): string {
    // Parse the time string
    const parts = timeString.split(':');
    const hours = parseInt(parts[0]);
    const minutes = parseInt(parts[1].split(' ')[0]);
    const period = parts[1].split(' ')[1];

    // Adjust hours if necessary
    let formattedHours = hours;
    if (period === 'PM' && hours < 12) {
      formattedHours += 12;
    } else if (period === 'AM' && hours === 12) {
      formattedHours = 0;
    }

    // Format hours and minutes with leading zeros
    const formattedTime = this.padZero(formattedHours) + ':' + this.padZero(minutes);

    return formattedTime;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : '' + num;
  }

  timezone_regions: {[index: string]: string} = {
    'America/Toronto': 'Eastern',
    'America/Vancouver': 'Pacific',
    'America/Edmonton': 'Mountain',
    'America/Montreal': 'Eastern',
    'America/Chicago': 'Central',
    'America/Halifax': 'Atlantic',
    'America/Dawson_Creek': 'Pacific',
    'America/Regina': 'Central',
    'America/Winnipeg': 'Central',
    'America/Los_Angeles': 'Pacific',
    'America/New_York': 'Eastern',
    'America/Detroit': 'Eastern',
    'America/Thunder_Bay': 'Eastern',
    'America/St_Johns': 'Newfoundland',
    'America/Swift_Current': 'Central',
    'America/Denver': 'Mountain',
    'America/Indiana/Indianapolis': 'Eastern',
    'America/Indiana/Knox': 'Eastern',
    'America/Indiana/Marengo': 'Eastern',
    'America/Indiana/Petersburg': 'Eastern',
    'America/Indiana/Tell_City': 'Eastern',
    'America/Indiana/Vevay': 'Eastern',
    'America/Indiana/Vincennes': 'Eastern',
    'America/Indiana/Winamac': 'Eastern',
    'America/Kentucky/Louisville': 'Eastern',
    'America/Kentucky/Monticello': 'Eastern',
    'America/North_Dakota/Beulah': 'Central',
    'America/North_Dakota/Center': 'Central',
    'America/North_Dakota/New_Salem': 'Central',
    'America/Boise': 'Mountain',
    'America/Whitehorse': 'Pacific',
    'America/Yellowknife': 'Mountain',
    'America/Rainy_River': 'Central',
    'America/Dawson': 'Pacific',
    'America/Rankin_Inlet': 'Central',
    'America/Goose_Bay': 'Atlantic',
    'America/Iqaluit': 'Eastern',
    'America/Inuvik': 'Mountain',
    'America/Juneau': 'Alaska',
    'America/Cambridge_Bay': 'Mountain',
    'America/Yakutat': 'Alaska'
  }

  constructor(private http: HttpClient, private fb: FormBuilder){}


}
